import {timetable_syncTimetableDetailMaterials_Api} from 'apis'
import {Button} from 'antd'
import DrawDialog from 'components/drawer/dialog/DrawDialog'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {PiLinkBold} from 'react-icons/pi'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify} from 'views/AppLocals/factory/createNotification'
import {MaterialRowsFields, useMaterialRows} from './TimetableDetailMaterialsForm'

// DrawDialog (bottom-sheet mobile / popup desktop) bản trigger-tại-chỗ của TimetableDetailMaterialsForm
// (Modal) - dùng ở nơi cần nút sửa gắn ngay tại từng buổi học trong 1 danh sách dài (vd
// MyClassSessionsPanel.js, view học viên "Lịch chi tiết" nhưng vẫn cho phép GV/admin lớp sửa tại chỗ),
// khác với useTimetableDetailMaterialsForm (1 Modal điều khiển từ ngoài, đang dùng ở
// CourseClassTimetablePanel.js - trang quản trị lịch riêng). Tái dùng đúng logic rows/build-payload
// qua useMaterialRows + MaterialRowsFields của file kia, chỉ khác phần chrome + tự đóng sau khi lưu.
const SessionMaterialsBody = ({session, onSaved, onClose}) => {
    const t = useTranslate()
    const {rows, setRow, removeRow, addRow, buildPayload} = useMaterialRows(session?.materials, true)

    const {handleAsyncAction: onSync, isLoading} = useAsyncAction({
        apiInfo: timetable_syncTimetableDetailMaterials_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            if (onSaved) onSaved()
            onClose()
        },
    })

    return (
        <div className="flex flex-col gap-3">
            <MaterialRowsFields rows={rows} setRow={setRow} removeRow={removeRow} addRow={addRow}/>
            <div className="flex justify-end gap-2 pt-2 border-t border-color-50">
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button
                    type="primary"
                    loading={isLoading}
                    onClick={() => onSync({materials: JSON.stringify(buildPayload())}, {id: session?.id})}>
                    {t('save')}
                </Button>
            </div>
        </div>
    )
}

// trigger - override nút mở drawer (mặc định nút text+icon như cũ) - dùng khi cần 1 nút gọn dạng
// icon-dot (vd MyClassSessionsPanel.js gộp 3 mục CHƯA có dữ liệu vào 1 hàng icon nhỏ thay vì 3 khung
// rỗng chiếm nhiều chỗ trên mobile, xem comment ở đó).
export const SessionMaterialsDrawer = ({session, onRefresh, trigger}) => {
    const t = useTranslate()
    return (
        <DrawDialog
            title={t('manage lecture materials')}
            width={480}
            component={
                trigger || (
                    <button
                        type="button"
                        title={t('manage lecture materials')}
                        className="flex items-center gap-1 text-2xs font-medium text-color-400 hover:text-indigo-600 whitespace-no-wrap">
                        <PiLinkBold size={11}/>
                        {t('materials')}
                    </button>
                )
            }>
            {(isToggle, toggle) => isToggle && (
                <SessionMaterialsBody session={session} onSaved={onRefresh} onClose={() => toggle(false)}/>
            )}
        </DrawDialog>
    )
}

export default SessionMaterialsDrawer
